// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indus_pop{overflow:auto;padding:15px 0;border:1px solid #282729;width:320px;height:360px;text-align:center;transform:translate(-44px)}", ""]);
// Exports
module.exports = exports;
